export default "__VITE_ASSET__dcd41f94__"